export * from "./renderTargetTexture.types";
/**
 * Re-exports pure implementation and applies runtime side effects.
 * Import renderTargetTexture.pure for tree-shakeable, side-effect-free usage.
 */
export * from "./renderTargetTexture.pure";
import { RegisterRenderTargetTexture } from "./renderTargetTexture.pure";
RegisterRenderTargetTexture();
//# sourceMappingURL=renderTargetTexture.js.map